import React from "react";

function Forms() {
  return <div>forms of all done her</div>;
}

export default Forms;
